module.exports = __webpack_public_path__ + "img/user.d80dd2f3.jpg";